export default __webpack_public_path__ + "static/media/katanyilmaz6.cc1c40ba.jpg";